/*
@file-overview

- This service contains a collection of global window methods availible on AEM pages and other SPA applications

- NOTE : many of these methods are NOT used in library, and need to still be cleaned for consuming apps

*/
import { Injectable, NgZone, signal } from '@angular/core';
import { HttpClient }         from '@angular/common/http';
import { CouponModel, CurrentOrderData, OffersData, ProductModel, ShopCouponRefresh }       from '../models/data.model';
import { HttpHeaders }        from '@angular/common/http';
import { BehaviorSubject }    from 'rxjs';
import { Subject }            from 'rxjs';
import { Observable }         from 'rxjs';
import { AemService } from './aem.service';
import { DatalayerService } from './datalayer.service';
import { UtilService } from './util.service';
import { UserInfoService } from './user-info.service';
import { ProductUtilService } from './product-util.service';

import { EnviormentConfig } from '../wcax-env-config';
import {filterApiConstants} from "../constants/filterApiConstants"

// Window global declaration
function _window (): any {
    return window;
}

// Jquery declaration
declare let $: any;

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    // DFTA - wcax env config
    private config = EnviormentConfig;

    private _disableInStoreChannelCheck = window['SWY']['CONFIGSERVICE']
        && window['SWY']['CONFIGSERVICE'].featureToggleConfig
        && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableInStoreChannelCheck')
            ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableInStoreChannelCheck
            : true;

    private _enableMFC2 = window['SWY']['CONFIGSERVICE']
        && window['SWY']['CONFIGSERVICE'].featureToggleConfig
        && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('isMFC2disabled')
        && window['SWY']['CONFIGSERVICE'].featureToggleConfig.isMFC2disabled === false;
    private _disableMto = window['SWY']['CONFIGSERVICE']
        && window['SWY']['CONFIGSERVICE'].featureToggleConfig
        && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableMto')
            ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableMto
            : true;

    private rewardGridPath: string = '/content/www/{banner}/en/justforyou/rewards/rewards-details';
    private _arrPromoRule = [];
    public objPageCoupons = {
        'offers': {},
        'offersByUpc': {}
    };
    public shopCouponRefreshSource = new BehaviorSubject<ShopCouponRefresh>({});

    public rewardsRefreshSource = new Subject<boolean>();
    public rewardsRefresh = this.rewardsRefreshSource.asObservable ();

    public postUserInfoSource = new Subject<string> ();
    public userInfoRefresh = this.postUserInfoSource.asObservable ();

    public _postUserInfoSource = new BehaviorSubject<string>('');
    public _userInfoRefresh = this._postUserInfoSource.asObservable ();

    public manualBootstrapSource = new Subject();
    public manualBootstrap = this.manualBootstrapSource.asObservable();

    public hideStepperButtons = new Subject();
    public $hideStepperButtons = this.hideStepperButtons.asObservable();

    public rightDrawerSource = new Subject<any>();
    public $rightDrawerSource = this.rightDrawerSource.asObservable();

    public upcs = new Subject<any>();
    public $upcs = this.upcs.asObservable();

    public customizationData = signal<any>({ isUpdated: false, selectedOptions: null, selectedQuantity: null, productId: null, comments:null });

    public bxgyOffer = new Subject<any>();
    public $bxgyOffer = this.bxgyOffer.asObservable();

    public arSubscriptions = new BehaviorSubject<any>(null);
    public $arSubscriptions = this.arSubscriptions.asObservable();

    public showHeaderTooltip = new BehaviorSubject<any>(false);

    public crossSellTargetSource = new Subject<{bpn: string, products: ProductModel[], isDynamicGridFlow?: boolean}>();
    public $crossSellTarget = this.crossSellTargetSource.asObservable();

    public crossSellCloseSource = new Subject();
    public $crossSellClose = this.crossSellCloseSource.asObservable();

    public _validateSession = new BehaviorSubject<any>({});
    public validateSession$ = this._validateSession.asObservable();

    public _updateBiaAddAllBtn = new Subject();
    public updateBiaAddAllBtn$ = this._updateBiaAddAllBtn.asObservable();

    public _cartObjSource = new BehaviorSubject<any>({});
    public currentCartObj = this._cartObjSource.asObservable();

    public _toasterInteractiveElement = new BehaviorSubject<any>(false);

    public _products = new BehaviorSubject<any>(null);
    public products$ = this._products.asObservable();


    public isABFlagDisabledEvent = new Subject<any>();
    public isABFlagDisabledEvent$ = this.isABFlagDisabledEvent.asObservable();
    public orderAmendsCurrentOrderData: CurrentOrderData;
    public isCateringEnabled: boolean;

    //Edit Order Flow
    private slotDisplay = '#poDeliveryDate';
    private reviewCTA = '#poCancelLink';
    private editOrderRowUI = '#pendingOrderAlert';
    private reserveTimeEl = '#reserveCon';
    private reserveNavEl = '.reserve-nav';
    private slotCookie = 'SlotInfo';
    private orderStoreCookie = 'OrderStoreId';
    private orderNumberCookie = 'OrderNumber';
    private isSyndicatedHeader = 'syndicatedHeader';
    private  eRumsDeliveryType = 'eRumsDeliveryType';
    private slotInfo: any;
    private orderStoreId: any;
    private duplicateProductsObj = {};
    // Routes where Criteo AD_CLICK is currently gated during AMC validation rollout.
    // Add a new route here to enable sponsored click tracking on that page.
    private static readonly CRITEO_CLICK_ALLOWED_ROUTES = ['/loyalty/discovery'];

    constructor (
        private http: HttpClient,
        zone: NgZone,
        private _aemService: AemService,
        private _datalayerService: DatalayerService,
        private _utilService: UtilService,
        private _userInfoService: UserInfoService,
        private _productUtilService: ProductUtilService) {
        this._arrPromoRule = _window ().SWY.CONFIGSERVICE.getConfigforPromoDesc ();
        this.isCateringEnabled = !this._aemService.getFeatureFlagByNameDisable('isCateringDisabled');

        // this.checkBoxTopRegistered();
    }

    /**
     * Gets all hidden inputs to bring data into Angular application.
     *
     * @see app.module.ts
     */
    public getHiddenInputs (): void {
        const wrapper: any = $ ( '.js-gridDataParse' );

        $ ( 'input[type="hidden"]', wrapper ).each ( function ( i, el ) {
            const $el = $ ( el );
            const val = $el.val ();
            const elName = $el.attr ( 'name' );

            if ( !val )
                return;

            switch ( elName ) {
                case 'gridDataSource':
                    window[ 'AB' ][ elName ] = JSON.parse ( val );
                    break;
                case 'availableSorts':
                    window[ 'AB' ][ elName ] = [];
                    val.split ( ',' ).map ( function ( elVal: any ) {
                        window[ 'AB' ][ elName ].push ( elVal.trim () );
                    } );
                    break;
                default:
                    window[ 'AB' ][ elName ] = val.toString ();
                    break;
            }
        } );
    }

    public getPromorulesArray () {
        return this._arrPromoRule;
    }

    public getBogoLabel (): string {
        return _window ().SWY.CONFIGSERVICE.getBannerConventions ().buy_one_get_one_free;
    }

    public getPromoDescription (): string {
        return _window ().SWY.CONFIGSERVICE.getBannerConventions ().promoDescription;
    }

    public getPromoDescriptionAPI ( product ) {

        if (this.isProductPromoActive(product)) {

            switch ( product.promoType ) {
                case 'P':
                    product['promoTitle'] = this.getPromoDescription();
                    product['offerText'] = '';
                    break;
                case 'B':
                case 'M':
                    product['promoTitle'] = this.getBogoLabel();
                    product['offerText'] = product['promoText'];
                    break;
            }
        }
    }
    public getPromoDescriptionAPIMealsRecipe(product) {

        if (this.isProductPromoActive(product)) {

            switch (product.promoType) {
                case 'P':
                    product['promoTitle'] = this.getPromoDescription();
                    product['offerText'] = '';
                    break;
                case 'B':
                case 'M':
                    product['promoTitle'] = this.getBogoLabel();
                    product['offerText'] = product['promoText'];
                    break;
            }
        }

        return product;
    }

    public getAppContext () {
        return _window ().AB;
    }

     /**
     * returns pdp page path based on program type
     * @param programType
     * **/
     public getProductDetailPath (programType?: string): string {
        if (programType === 'wineshop') {
            return _window ().AB.winePdpPath;
        } else if (programType === 'mkp'){
            return _window().AB.mkpPdpPath;
        } else {
            return _window().AB.htmlProductDetailPath;
        }
    }

    public isSeoEnabled(): boolean {
        const featureToggleConfig = window['SWY'] && window['SWY'].CONFIGSERVICE &&
            window['SWY'].CONFIGSERVICE.featureToggleConfig;
        return featureToggleConfig?.isSeoEnabled === true;
    }

    private generateSeoSlug(title: string): string {
        if (!title || title.trim() === '') {
            return 'product';
        }

        const unitMap: { [key: string]: string } = {
            'fluid oz': 'fl-oz',
            'fl oz': 'fl-oz',
            'fluid ounces': 'fl-oz',
            'fluid ounce': 'fl-oz',
            'ounces': 'oz',
            'ounce': 'oz',
            'pounds': 'lb',
            'pound': 'lb',
            'count': 'ct',
            'pk': 'pack'
        };

        const stopWordsRegex = /\b(a|an|the)\b/g;

        let slug = title.toLowerCase()
            .replace(/[\u2122\u00ae\u00a9]/g, '')
            .replace(/&/g, ' and ')
            .replace(/[\u2018\u2019'`]/g, '')
            .replace(/\//g, '-')
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/(\d)\.(\d)/g, '$1-$2')
            .replace(/([a-z0-9])\s*\+/g, '$1 plus ')
            .replace(/(\d)\s*%/g, '$1 percent ')
            .replace(/#\s*(\d+)/g, ' number $1')
            .replace(/[.,;:"()[\]{}!?@$^*=~<>|\\]/g, ' ')
            .replace(/[^a-z0-9\s-]/g, ' ');

        Object.keys(unitMap).forEach((unit) => {
            slug = slug.replace(new RegExp('\\b' + unit + '\\b', 'g'), unitMap[unit]);
        });

        slug = slug
            .replace(stopWordsRegex, ' ')
            .replace(/\b(\d+)\s*pack\b/g, '$1-pack')
            .replace(/\b(\d+)\s*ct\b/g, '$1-ct')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-+|-+$/g, '');

        if (slug.length > 120) {
            const trimmedSlug = slug.substring(0, 120);
            const lastHyphen = trimmedSlug.lastIndexOf('-');
            slug = lastHyphen > 0 ? trimmedSlug.substring(0, lastHyphen) : trimmedSlug;
        }

        return slug || 'product';
    }

    public buildSeoPdpUrl(productName: string, bpn: string): string {
        return `/shop/pd/${this.generateSeoSlug(productName)}/${bpn}`;
    }

    public getCouponDetailPathShop (): string {
        return _window ().AB.htmlOfferDetailPathShop;
    }

    public getCouponDetailPathWww (): string {
        return _window ().AB.htmlOfferDetailPathWww;
    }

    public getRewardGridPathWww (): string {
        return _window ().AB.htmlRewardDetailPathWww;
    }

    public promoDescription ( product ) {

        const newField = 'promoDescriptionVal';
        const priceColor = 'priceColor';

        const strPromoDesc = product.promoDescription;
        let found: boolean = false;

        if ( !strPromoDesc ) {
            return;
        }

        console.log ( 'PRODUCT DESCRIPTION - DATA: ' + strPromoDesc );

        for ( let i = 0; i < this._arrPromoRule.length && found === false; i++ ) {
            const objRule = this._arrPromoRule[ i ];
            if ( strPromoDesc.match ( objRule[ 'rule' ] ) ) {
                product[ newField ] = objRule[ 'value' ];
                product[ priceColor ] = objRule[ 'priceColor' ];
                product[ 'offerText' ] = objRule[ 'offerText' ];
                found = true;
                objRule[ 'showStrikeThrough' ] == true && this.checkStrikeThrough ( product );
                console.log ( 'PRODUCT DESCRIPTION - MODIFIED: ' + product[ newField ] );
            }
        }

        if ( found === false ) {
            product[ newField ] = _window ().SWY.CONFIGSERVICE.getBannerConventions ().promoDescription;
            console.log ( 'PRODUCT DESCRIPTION - DEFAULT: ' + product[ newField ] );
            product[ priceColor ] = true;
            this.checkStrikeThrough ( product );
            product[ 'offerText' ] = '';
        }
    }

    public checkStrikeThrough(product) {

        if (
            this.isProductPromoActive(product)
            && product[ 'promoType' ] === 'P'
            && product[ 'basePrice' ] != null
            && product[ 'price' ] > 0.00
            && product[ 'basePrice' ] > 0.00
            && product[ 'price' ] < product[ 'basePrice' ]
        ) {
            product[ 'showStrikeThrough' ] = true;

        } else {
            this.setStrikeThroughFromBadge(product);
        }
    }

    private setStrikeThroughFromBadge(product) {
        product?.badges?.forEach(badge => {
            if (badge?.isStrikethrough) {
                product['showStrikeThrough'] = true;
                product['basePrice'] = product.previousBasePrice;
                product['priceHighlight'] = false;
                product['priceIndicator'] = 'Now';
            }
        });
    }
    
    public checkStrikeThroughSponsored(product) {

        if (
            this.isProductPromoActive(product)
            && product[ 'basePrice' ] != null
            && product[ 'price' ] > 0.00
            && product[ 'basePrice' ] > 0.00
            && product[ 'price' ] < product[ 'basePrice' ]
        ) {
            product[ 'showStrikeThrough' ] = true;

        } else {
            product[ 'showStrikeThrough' ] = false;
        }
    }

    public getUidValue(){
        return document.cookie.match('(^|;)\\s*_br_uid_2\\s*=\\s*([^;]+)') || '';
    }

    public _hasLSRewards () {
        const objRewards = this._getRewards ();
        return ( objRewards &&
                 objRewards[ 'grOffers' ] ) ? true : false;
    }

    public _hasLSArSubscriptions () {
        const currentTime = Date.now();
        const objSubscriptions = this._getArSubscriptions ();
        return objSubscriptions && objSubscriptions['arSavedTime'] > currentTime;
    }

    private _getArSubscriptions () {
        const subsKey = 'abNgSubscriptions';
        const arSubs = localStorage.getItem ( subsKey );
        let objSubscriptions = {};
        try {
            objSubscriptions = JSON.parse ( arSubs );
        } catch ( e ) {
            console.error ( 'ERROR: AR SUBSCRIPTIONS - GETTING FROM LOCAL STORAGE' );
            console.error ( e );
        }

        return objSubscriptions;
    }

    private _getRewards () {
        const strRewards = localStorage.getItem ( 'abRewards' );
        let objRewards = {};
        try {
            objRewards = JSON.parse ( strRewards );
        } catch ( e ) {
            console.error ( 'ERROR: REWARDS - GETTING FROM LOCAL STORAGE' );
            console.error ( e );
        }

        return objRewards;
    }

    public _hasLSDeals () {
        const objDeals = this._getDeals ();
        return objDeals ? true : false;
    }

    private _getDeals () {
        const strDeals = localStorage.getItem ( 'abDeals' );
        let objDeals = {};
        try {
            objDeals = JSON.parse ( strDeals );
        } catch ( e ) {
            console.error ( 'ERROR: DEAL - GETTING FROM LOCAL STORAGE' );
            console.error ( e );
        }

        return objDeals;
    }

    public loadRemoteCouponsV2(category) {
        let couponPath = '';
        category = filterApiConstants[category] || category;
        if ( _window ().AB.COMMON.authorize () ) {
            couponPath = _window ().AB.offerGalleryFilterPath;
        } else {
            const dpConf = _window ().SWY.CONFIGSERVICE.getDatapowerConfig();
            const xAPIBaseUrl = dpConf.clientHost + dpConf.datapowerxAPIBasePath;
            couponPath = xAPIBaseUrl + '/dce/offergallery/anonymous/offers/filter';
        }

        couponPath += '?storeId=' + _window ().AB.userInfo.branchId;

        return this.getRemoteCouponsV2(couponPath, category);
    }

    public getRemoteCouponsV2(couponPath, category): Observable<any> {
        const httpHeaders = {
            "Content-Type": "application/json",
            "X-SWY_API_KEY": "emju",
            "X-SWY_VERSION": "3.0",
            "Ocp-Apim-Subscription-Key": this._aemService.getApimSubscriptionKey()
        };
        if (_window ().AB.COMMON.authorize () && this._userInfoService.getSWY_SHOP_TOKEN()) {
            httpHeaders['Authorization'] = `Bearer ${this._userInfoService.getSWY_SHOP_TOKEN()}`;
        }
        const httpOptions = {
            headers: new HttpHeaders(httpHeaders)
        };
        const payload = {
            primaryCategoryNm: [category]
        };
        return this.http.post(couponPath, payload, httpOptions);
    }

    public isEmpty(obj) {
      // null and undefined are "empty"
      if (obj == null) return true;

      // Assume if it has a length property with a non-zero value
      // that that property is correct.
      if (obj.length > 0) return false;
      if (obj.length === 0) return true;

      // If it isn't an object at this point
      // it is empty, but it can't be anything *but* empty
      // Is it empty?  Depends on your application.
      if (typeof obj !== "object") return true;

      // Otherwise, does it have any properties of its own?
      // Note that this doesn't handle
      // toString and valueOf enumeration bugs in IE < 9
      for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
      }

      return true;
    }

    /**
     * Retrieves an offer with a specific delivery channel (EC) from the provided offers data.
     * The method first checks for the offer in the `upcs` section using the provided UPC.
     * If not found, it then checks in the `departments` section using the provided department ID.
     *
     * @param offersData - The data containing offers, organized by UPCs and departments.
     * @param upc - The unique product code (UPC) used to locate offers in the `upcs` section.
     * @param departmentId - The department ID used to locate offers in the `departments` section.
     * @returns The found offer as a `CouponModel` if available, or `null` if no matching offer is found.
     */
    public getOfferWithDeliveryChannelEC(offersData: OffersData, upc: string, departmentId: string): CouponModel | null {
        if (this.isEmpty(offersData)) return null;

        let snsOffer = null;

        // Check in upcs["upc"].offers
        const upcsOffers = offersData?.upcs?.[upc]?.offers;
        if (upcsOffers) {
            snsOffer = this.findOfferWithDeliveryChannelEC(upcsOffers);
            if (snsOffer !== null) {
                return snsOffer; // Return immediately if found in upcs
            }
        }

        // Check in departments["id"].offers only if not found in upcs
        const departmentsOffers = offersData?.departments?.[departmentId]?.offers;
        if (departmentsOffers) {
            snsOffer = this.findOfferWithDeliveryChannelEC(departmentsOffers);
            if (snsOffer !== null) {
                return snsOffer;
            }
        }

        return snsOffer;
    }


    /**
     * Finds and returns the first offer from the provided list of offers that has a delivery channel of "EC".
     * If no such offer is found or the list is empty, returns `null`.
     *
     * @param offers - An array of `CouponModel` objects to search through.
     * @returns The first `CouponModel` with a delivery channel of "EC", or `null` if none is found.
     */
    public findOfferWithDeliveryChannelEC(offers: Record<string, CouponModel>): CouponModel | null {
        if (this.isEmpty(offers)) return null;
        for (const offerId in offers) {
            const offer = offers[offerId];
            if (offer?.deliveryChannel === "EC") {
                return offer;
            }
        }
        return null;
    }

    public isCouponExpired(coupon) {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const dateString = `${month}/${day}/${year}`;
        const finalDate = new Date(dateString);


        const endDateMilliSeconds = parseInt(coupon.endDate);
        const endDate = new Date(endDateMilliSeconds);
        const endDay = endDate.getDate();
        const endMonth = endDate.getMonth() + 1;
        const endYear = endDate.getFullYear();
        const couponendDateString = `${endMonth}/${endDay}/${endYear}`;
        const couponEndDate = new Date(couponendDateString);

        return couponEndDate < finalDate
    }

    /**
     * Check Unattended Delivery and restricted items.
     *
     * @returns {boolean} It's true if item is restricted and false if it's not restricted.
     */
    public checkUnAttendedDelivery ( product?: ProductModel ): boolean {
        if ( this.checkPendingOrder() && this._aemService.checkUnAttendedDelivery() && product[ 'restrictedValue' ] && product[ 'restrictedValue' ] > 0 )
            return true;
        else
            return false;
    }

/*
   * Method checking and returning product offers by product upc code.
   * Uses the new offers structure (upcs property) with fallback to old structure.
   *
   * @param product
   * @param allOffers
   */
    public getOffersByUpc(product: any, allOffers: any) {
        const upc = product.upc;
        // Use the newer offers structure (upcs property) with fallback to old structure
        return  allOffers?.upcs?.[upc] ?? {};
    }

    /**
     * Get coupon type mapping.
     *
     * @param {string} type Coupon type: MF, PD, CC, SC.
     */
    public getCouponType ( type: string ): string {
        const couponTypes = this._aemService.getCouponTypes();
        return ( couponTypes[ type ] == undefined ) ? '' : couponTypes[ type ];
    }

    public prop65WarningMessage ( product ) {

        const prop65Details = ( this._aemService.getProp65Details() );
        product[ 'prop65WarningTextDetails' ] = '';

        if ( prop65Details.prop65Flag ) {

            product[ 'prop65Title' ] = '';
            product[ 'prop65PdpTitle' ] = '';

            if ( product[ 'prop65WarningText' ] != null && product[ 'prop65WarningText' ] != '' ) {
                product[ 'prop65Title' ] = prop65Details.prop65Title;
                product[ 'prop65PdpTitle' ] = prop65Details.prop65PDPTitle;
                product[ 'prop65WarningTextDetails' ] = product[ 'prop65WarningText' ];

            }

        }
    }

    public initServiceCall() {
        console.log('ANGULAR - REQUESTED SERVICE CALL');
        this.postUserInfoSource.next('initAngular');
    }

    public initJ4UModal() {
        console.log('ANGULAR - OPENING THE J4U MODAL');
        const objData = {
            manualComponentId: 'j4uModal',
            contextId: 'offerDetailModal'
        };

        this.manualBootstrapSource.next(objData);
    }

    public clipEcomGalleryCoupon(couponId) {
        this.shopCouponRefreshSource.next ({id: couponId, deleted: false, status: 'C' });
    }

    public unclipEcomGalleryCoupon(couponId) {
        this.shopCouponRefreshSource.next ({id: couponId, deleted: true, status: 'U' });
    }

    public checkBoxTopRegistered = function () {
        if (this._aemService.authorize()) {
            this.userInfoRefresh.subscribe((data) => {
                if (data == 'initFunc') {
                    if (this._aemService.authorize() && (!this._aemService.getBoxTopCalled())) {
                        this._aemService.setBoxTopCalled(true);
                        if (localStorage.getItem('loyaltyPartners')) {
                            const boxtopData = JSON.parse(localStorage.getItem('loyaltyPartners'));
                            if (boxtopData['loyaltyPartners']) {
                                boxtopData['loyaltyPartners'].forEach(function (loyaltyPartner) {
                                    if ((loyaltyPartner) && (loyaltyPartner.name == 'GeneralMills') && (loyaltyPartner.planNumber) && (loyaltyPartner.planNumber.length > 1)) {
                                        this._aemService.setBoxTopAuth(true);
                                    }
                                });
                            }
                        } else {
                            this.objBoxTop.getGeneralMillsId().subscribe(boxtopData => {
                                localStorage.setItem('loyaltyPartners', JSON.stringify(boxtopData));
                                if (boxtopData['loyaltyPartners']) {
                                    boxtopData['loyaltyPartners'].forEach(function (loyaltyPartner) {
                                        if ((loyaltyPartner) && (loyaltyPartner.name == 'GeneralMills') && (loyaltyPartner.planNumber) && (loyaltyPartner.planNumber.length > 1)) {
                                            this._aemService.setBoxTopAuth(true);
                                        }
                                    });
                                }
                            });
                        }
                    }
                }
            });
        }
    };

    public isProductPromoActive(product) {

        let check = false;

        if (
            product.hasOwnProperty('promoEndDate')
            && product.promoEndDate
        ) {

            const today = new Date();
            const day = today.getDate();
            const month = today.getMonth() + 1;
            const year = today.getFullYear();
            const dateString = `${month}/${day}/${year}`;
            const finalDate = new Date(dateString);

            const promoEndDateTime = new Date(product.promoEndDate);

            if (finalDate <= promoEndDateTime) {
                check = true;
            }
        }

        return check;
    }

    public hasPromotion(product) {

        let check = false;

        if (
            product.hasOwnProperty('promoType')
            && product.promoType
            && (
                product.promoType === 'P'
                || product.promoType === 'B'
                || product.promoType === 'M'
            )
        ) {

            check = true;
        }

        return check;
    }

    public showCrossSell(bpn, aisleId, productsInCart, crossSellType) {
        const storeId = this._aemService.getBranchId();

        if (aisleId && storeId && bpn) {

            const searchConfig = this._aemService.getApimSearchPath();
            const endpoint = this._aemService.getApimSearchSponsoredCarouselEndpoint();
            const elevateSessionId: string = encodeURIComponent(this._aemService.getCookie('_elevaate_session_id'));
            const width = $(window).width();
            const userId = (this._aemService.clubCard())? encodeURIComponent(this._aemService.clubCard()) : '';
            const banner = this._aemService.getBanner();
            let excludedBpns = bpn;
            let url = '';

            if (!crossSellType)
                crossSellType = "cross-sell";

            if (productsInCart.length > 0) {
                productsInCart.forEach(function (product) {
                    excludedBpns = excludedBpns + ',' + product;
                });
            }

            url = `${window.location.origin}${searchConfig}${endpoint}`
                + `?storeid=${storeId}`
                + `&featuredsessionid=${elevateSessionId}`
                + `&screenwidth=${width}`
                + `&userid=${userId}`
                + `&banner=${banner}`
                + `&max-result=8`
                + `&pagename=${crossSellType}`
                + `&exclude-bpn=${excludedBpns}`
                + `&bpn=${bpn}`
                + `&category-id=${aisleId}`;

            url = this.generateCBAUrl(url);

            const httpOptions = { headers: new HttpHeaders({
                'Ocp-Apim-Subscription-Key': this._aemService.getApimSubscriptionKey()
            })};

            this.http.get<ProductModel[]>(url, httpOptions).subscribe(( objResponse ) => {
                if(objResponse['response']?.docs){
                    const formattedResponse = {'products': objResponse['response']?.docs, 'bpn': bpn};
                    this.sendSponsoredProductsOnloadEvent(objResponse['response']?.docs, 'crossSellComponent');
                    this.crossSellTargetSource.next(formattedResponse);
                }
            });
        }
    }

    public closeCrossSell(bpn) {

        const crossSellCheck = document.getElementsByClassName('cross-sell-product-' + bpn)[0];
        if (crossSellCheck) {
            this.crossSellCloseSource.next(true);
        }
    }

    public isGuestUser() {
        const featureFlagConfig = this._aemService.featureToggleConfig();
        const isGuestCartFlagConfigDisabled =
            featureFlagConfig && featureFlagConfig.hasOwnProperty('disableGuestCart')
            ? featureFlagConfig.disableGuestCart
            : true;
        return String(_window ().AB.userInfo.userType).toLowerCase() == 'g' && !isGuestCartFlagConfigDisabled;
    }

    /**
     * Method validating the CBA flow for a given product.
     * It returns true/false based on the product overall availability.
     *
     * @param {any} product - Object of the product on which the CBA check is being done
     * @return {boolean}
     */
    public isItemAvailable(product: any): boolean {

        // README: Flag used to validate Angular template content based on inStore feature validity
        product['disableInStoreUICheck'] = true;

        /*
        * README:
        * Get channel object key based on the channel chosen by the user.
        * This value will be used to validate the specific channelEligibility flag from product object.
        */
        let userChannelChoice = this._aemService.getUserChannel();
        const channelKeyName = (() => {

            switch (true) {

                case userChannelChoice === 'pickup':
                    return 'pickUp';

                case userChannelChoice === 'delivery':
                    return 'delivery';

                case (
                    !this._disableInStoreChannelCheck
                    && userChannelChoice === 'instore'
                ):
                    return 'inStore';

                default:
                    return '';
            }
        })();

        // FIXME: Remove this when the disableInStoreChannelCheck feature flag will be removed
        if (this._disableInStoreChannelCheck && userChannelChoice === 'instore') {
            userChannelChoice = '';
        }

        // README: Check the appropriate channeel flag inside channelEligibility object of the product
        const channelEligibilityObject = product.channelEligibility;
        const isProductEligible = channelEligibilityObject && channelEligibilityObject[channelKeyName]
            ? channelEligibilityObject[channelKeyName]
            : false;

        switch (true) {

            // README: Scenario 1 - If user sets instore channel
            case (
                !this._disableInStoreChannelCheck
                && userChannelChoice === 'instore'
            ):

                if (isProductEligible) {

                    // README: The product must not be eligible for delivery or pickup either
                    if (
                        !channelEligibilityObject['delivery']
                        && !channelEligibilityObject['pickUp']
                    ) {
                        product['disableInStoreUICheck'] = false;
                    }

                    // README: Scenario 1A - if product is eligible
                    return this.checkItemAvailability(product, userChannelChoice);

                } else {

                    // README: Scenario 1B - if product is not eligible
                    product['itemNotAvailableTxt'] = 'This item is not offered for in-store.';
                }

                return false;

            // README: Scenario 2 - If user sets pickup or delivery channel
            case ['pickup', 'delivery'].includes(userChannelChoice):

                if (isProductEligible) {

                    // README: Scenario 2A/B - if product is eligible
                    return this.checkItemAvailability(product, userChannelChoice);

                } else {

                    // README: Scenario 2C/D - if product is not eligible
                    product['itemNotAvailableTxt'] = `This item is not offered for ${userChannelChoice}.`;
                }

                return false;

            // README: Scenario 3 - If channel is not set by user
            case !userChannelChoice:

                return this.checkItemAvailability(product, userChannelChoice);

            // README: Scenario 4 (default) - By default the product is treated as not available
            default:
                return false;
        }
    }

    /**
     * Method validating the availability flow for a given product. This method handles the out of stock (OOS) check.
     * It returns true/false based on product stock availability.
     *
     * @param {any} product - Object of the product on which the availability check is being done
     * @param {string} userChannelChoice - Label for the user channel
     * @return {boolean}
     */
    public checkItemAvailability(product: any, userChannelChoice: string): boolean {

        if (product) {

            switch (true) {

                // README: Scenario 1 - When user sets instore channel and product is valid
                case (
                    !this._disableInStoreChannelCheck
                    && userChannelChoice === 'instore'
                    && product.price > 0
                ):
                // README: Scenario 2 - When user sets pickup or delivery channel and product is valid
                case (
                    ['pickup', 'delivery'].includes(userChannelChoice)
                    && product.price > 0
                    && product.inventoryAvailable === '1'
                ):
                // README: Scenario 3 - When channel is not set and product is valid
                case (
                    !userChannelChoice
                    && product.price > 0
                ):
                    product['itemAvailable'] = true;
                    return true;

                // README: Scenario 5 (default) - When product is not valid / if product price <= 0
                default:
                    product['itemAvailable'] = false;
                    product['itemNotAvailableTxt'] = 'This item is out of stock';
                    product['disableInStoreUICheck'] = true;
                    return false;
            }
        }

        return false;
    }

    /**
     * This Method appends the channel as a param and forms a new url (Needed for Channel Eligibility)
     *
     * @param {string} strUrl This is the Url.
     */

    public generateCBAUrl(strUrl: string) {

        if (strUrl !== '') {

            let url = '';
            let channel = this._aemService.getUserChannel();

            if (this._disableInStoreChannelCheck && channel === 'instore') {
                channel = '';
            }

            switch (true) {

                case channel === 'delivery':
                case channel === 'pickup':
                case !this._disableInStoreChannelCheck && channel === 'instore':

                    const idx = strUrl.indexOf('?');

                    if (idx < 0) {
                        url = `${strUrl}?channel=${channel}`;
                    } else {
                        url = `${strUrl}&channel=${channel}`;
                    }
                    break;

                default:
                    url = strUrl;
                    break;
            }

            return url;
        }

    }

    /**
     * This is a helper function for checking if an object not empty and has valid data.
     *
     * @param {object} objectToCheck Object to check.
     */
    public isObjectValid(objectToCheck: object) {
        return objectToCheck && objectToCheck.constructor === Object && !!Object.keys(objectToCheck).length;
    }

    // AR - Project : Will return true if
    // 1. Query Param has offerType='SAS'
    // 2. AR feature flag is ON
    // 4. User is logged-in
    public canTriggerProductsCall(): boolean {
        const featureFlagConfig = window['SWY'].CONFIGSERVICE.featureToggleConfig;
        const isArEnabled = featureFlagConfig && featureFlagConfig.arEnable;

        return isArEnabled && window['AB']['COMMON'].authorize();
    }

    /**
     * Method validating the CBA flow for a given product.
     * It returns true/false based on the product overall availability.
     *
     * @param {any} product - Object of the product on which the CBA check is being done
     * @return {boolean}
     */
     public isItemAvailable_v2(product: any, programType?): boolean {

        // README: Flag used to validate Angular template content based on inStore feature validity
        product['disableInStoreUICheck'] = true;

        /*
        * README:
        * Get channel object key based on the channel chosen by the user.
        * This value will be used to validate the specific channelEligibility flag from product object.
        */
        let userChannelChoice = this._userInfoService.getUserChannel();
        userChannelChoice = (programType === 'wineshop' || programType === 'wine-carousel') ? 'shipping' : userChannelChoice;
        const channelKeyName = (() => {

            switch (true) {
                case userChannelChoice === 'shipping':
                    return 'shipping';

                case userChannelChoice === 'pickup':
                    return 'pickUp';

                case userChannelChoice === 'delivery':
                    return 'delivery';

                case userChannelChoice === 'instore':
                    return 'inStore';

                default:
                    return '';
            }
        })();

        // README: Check the appropriate channeel flag inside channelEligibility object of the product
        const channelEligibilityObject = product.channelEligibility;
        const isProductEligible = channelEligibilityObject && channelEligibilityObject[channelKeyName]
            ? channelEligibilityObject[channelKeyName]
            : false;
        if(typeof product.status != "undefined" && product.status == "inactive") {
            product['itemAvailable'] = false;
            product['itemNotAvailableTxt'] = 'This item is out of stock';
            product['disableInStoreUICheck'] = true;
        }
        else {
            const shouldBypassEligibility = !this.isFeatureEnabled('isMtoChannelEligibilityEnabled') && product.isMtoProduct;
            if (shouldBypassEligibility) {
                return this.checkItemAvailability_v2(product, userChannelChoice);
            }
            switch (true) {

                // README: Scenario 1 - If user sets instore channel
                case userChannelChoice === 'instore':

                    if (isProductEligible) {

                        // README: The product must not be eligible for delivery or pickup either
                        if (
                            !channelEligibilityObject['delivery']
                            && !channelEligibilityObject['pickUp']
                        ) {
                            product['disableInStoreUICheck'] = false;
                        }

                        // README: Scenario 1A - if product is eligible
                        return this.checkItemAvailability_v2(product, userChannelChoice);

                    } else {

                        // README: Scenario 1B - if product is not eligible
                        product['itemNotAvailableTxt'] = 'This item is not offered for in-store.';
                    }

                    return false;

                // README: Scenario 2 - If user sets pickup or delivery channel
                case ['pickup', 'delivery', 'shipping'].includes(userChannelChoice):

                    if (isProductEligible) {

                        // README: Scenario 2A/B - if product is eligible
                        return this.checkItemAvailability_v2(product, userChannelChoice);

                    } else {

                        // README: Scenario 2C/D - if product is not eligible
                        product['itemNotAvailableTxt'] = `This item is not offered for ${userChannelChoice}.`;
                    }

                    return false;

                // README: Scenario 3 - If channel is not set by user
                case !userChannelChoice:

                    return this.checkItemAvailability_v2(product, userChannelChoice);

                // README: Scenario 4 (default) - By default the product is treated as not available
                default:
                    return false;
            }
        }
    }

    /**
     *  ** Handles giving the correct out of stock messaging for BIA OOS redesign
     *
     * Method validating the Channel Based Availibility flow for a given product.
     * It returns true/false based on the product overall availability.
     *
     * @param {any} product - Object of the product on which the CBA check is being done
     * @return {boolean}
     */
    public isItemAvailable_v3(product: any, programType?, isPcRedesign=false, isDigitalDeliProductStoreNotEligible = false, isEligibleCustomCakeProduct = false): boolean {
        product['disableInStoreUICheck'] = true;


        const outOfStockMessage = isPcRedesign?'Out of stock':'Out of Stock';
        const pickupOnlyText = isPcRedesign?'Pickup only':'Only Available for Drive-up and go.';
        const inStoreOnlyText = isPcRedesign?'In-store only':'Only Available In-Store.';
        const deliveryOnlyText = isPcRedesign?'Delivery only':'Only Available for Delivery.';
        const deliveryAndPickupText = isPcRedesign?'Delivery and Pickup only':'Only Available for Delivery or Drive-up and go.';
        const inStoreAndDeliveryText = isPcRedesign?'In-store and Delivery only':'Only Available In-Store or for Delivery.';
        const inStoreAndPickupText = isPcRedesign?'In-store and Pickup only':'Only Available In-Store or for Drive-up and go.';

        /*
        * Get channel object key based on the channel chosen by the user.
        * This value will be used to validate the specific channelEligibility flag from product object.
        */
        let userChannelChoice = this._userInfoService.getUserChannel();
        userChannelChoice = (programType === 'wineshop' || programType === 'wine-carousel') ? 'shipping' : userChannelChoice;
        const checkPendingOrderStatus = this.checkPendingOrder();
        if(checkPendingOrderStatus){
            const abSlotEditOrder = localStorage.getItem('abSlotEditOrder');
            userChannelChoice = (JSON.parse(abSlotEditOrder)?.serviceType ?? userChannelChoice);
        }

        const channelKeyName = (() => {
            switch (true) {
                case userChannelChoice === 'shipping':
                    return 'shipping';

                case userChannelChoice === 'pickup':
                    return 'pickUp';

                case userChannelChoice === 'delivery':
                    return 'delivery';

                case userChannelChoice === 'instore':
                    return 'inStore';

                default:
                    return '';
            }
        })();

        // Check the appropriate channel flag inside channelEligibility object of the product
        const channelEligibilityObject = product.channelEligibility;
        const isProductEligible = channelEligibilityObject && channelEligibilityObject[channelKeyName]
            ? channelEligibilityObject[channelKeyName]
            : false;
        if(typeof product.status != "undefined" && product.status == "inactive") {
            product['itemAvailable'] = false;
            product['itemNotAvailableTxt'] = outOfStockMessage;
            product['disableInStoreUICheck'] = true;
        }
        else {
            // README: When isMtoChannelEligibilityEnabled flag is false, MTO products bypass the
            // channel eligibility check so that an active CTA is shown on the product card regardless
            // of the user's current fulfillment mode (channel agnostic discovery - product card scope only).
            const shouldBypassEligibility = !this.isFeatureEnabled('isMtoChannelEligibilityEnabled') && product.isMtoProduct;
            if (shouldBypassEligibility) {
                return this.checkItemAvailability_v3(product, userChannelChoice,outOfStockMessage);
            }
            switch (true) {
                // is digital deli enabled product, multicustomization only instore eligible
                case isDigitalDeliProductStoreNotEligible && !isEligibleCustomCakeProduct:
                    return this.checkItemAvailability_v3(product, userChannelChoice, inStoreOnlyText, isDigitalDeliProductStoreNotEligible);
                // Scenario 1 - If user sets instore channel
                case userChannelChoice === 'instore':

                    if (isProductEligible) {

                        // README: The product must not be eligible for delivery or pickup either
                        if (
                            !channelEligibilityObject['delivery']
                            && !channelEligibilityObject['pickUp']
                        ) {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreOnlyText;
                        }

                        return this.checkItemAvailability_v3(product, userChannelChoice,outOfStockMessage );

                    } else {
                        // if product is not eligible for instore
                        // check if item is availible for delivery or DUG
                        const deliveryAvailbile   = ( channelEligibilityObject?.['delivery']  &&  this.checkItemAvailability_v3(product, 'delivery',outOfStockMessage))
                        const dugAvailbile        = ( channelEligibilityObject?.['pickUp']    &&  this.checkItemAvailability_v3(product, 'pickup',outOfStockMessage))

                        if ( deliveryAvailbile && dugAvailbile )
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = deliveryAndPickupText;
                        }
                        else if ( !deliveryAvailbile && dugAvailbile )
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = pickupOnlyText;
                        }
                        else if ( deliveryAvailbile && !dugAvailbile )
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = deliveryOnlyText;
                        } else
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = outOfStockMessage;
                        }
                    }

                    return false;

                // Scenario 2 - If user sets pickup channel
                case userChannelChoice === 'pickup':

                    if (isProductEligible) {

                        return this.checkItemAvailability_v3(product, userChannelChoice,outOfStockMessage);

                    } else {
                        // if product is not eligible for pickup
                        // check if item is availible for delivery or instore
                        const deliveryAvailbile   = ( channelEligibilityObject?.['delivery']  && this.checkItemAvailability_v3(product, 'delivery',outOfStockMessage))
                        const instoreAvailbile    = ( channelEligibilityObject?.['inStore']   && this.checkItemAvailability_v3(product, 'instore',outOfStockMessage))

                        if ( deliveryAvailbile && instoreAvailbile )
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreAndDeliveryText;
                        }
                        else if ( !deliveryAvailbile && instoreAvailbile )
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreOnlyText;
                        }
                        else if ( deliveryAvailbile && !instoreAvailbile )
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = deliveryOnlyText;
                        } else
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = outOfStockMessage;
                        }
                    }

                    return false;

                // Scenario 3 - If user sets delivery channel
                case userChannelChoice === 'delivery':

                    if (isProductEligible) {

                        return this.checkItemAvailability_v3(product, userChannelChoice,outOfStockMessage);

                    } else {
                        // if product is not eligible for delivery
                        // check if item is availible for pickup or instore
                        const dugAvailbile        = ( channelEligibilityObject?.['pickUp']    && this.checkItemAvailability_v3(product, 'pickup',outOfStockMessage))
                        const instoreAvailbile    = ( channelEligibilityObject?.['inStore']   && this.checkItemAvailability_v3(product, 'instore',outOfStockMessage))

                        if ( dugAvailbile && instoreAvailbile )
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreAndPickupText;
                        }
                        else if ( dugAvailbile && !instoreAvailbile )
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = pickupOnlyText;
                        }
                        else if ( !dugAvailbile && instoreAvailbile )
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = inStoreOnlyText;
                        } else
                        {
                            product['disableInStoreUICheck'] = false;
                            product['itemNotAvailableTxt'] = outOfStockMessage;
                        }
                    }

                    return false;

                case userChannelChoice === 'shipping':
                    if (isProductEligible) {

                        // README: Scenario 2A/B - if product is eligible
                        return this.checkItemAvailability_v3(product, userChannelChoice, outOfStockMessage);

                    } else {

                        // README: Scenario 2C/D - if product is not eligible
                        product['itemNotAvailableTxt'] = `This item is not offered for ${userChannelChoice}.`;
                    }


                // Scenario 4 - If channel is not set by user
                case !userChannelChoice:

                    return this.checkItemAvailability_v3(product, userChannelChoice,outOfStockMessage);

                // Scenario 5 (default) - By default the product is treated as not available
                default:
                    return false;
            }
        }
    }

        /**
     * Method validating the availability flow for a given product. This method handles the out of stock (OOS) check.
     * It returns true/false based on product stock availability.
     *
     * @param {any} product - Object of the product on which the availability check is being done
     * @param {string} userChannelChoice - Label for the user channel
     * @return {boolean}
     */
        public checkItemAvailability_v2(product: any, userChannelChoice: string, validatePrice: boolean = true): boolean {

            if (product && product.channelInventory && product.channelInventory[userChannelChoice]) {

                //product.channelInventory[userChannelChoice] will be used instead of product.inventoryAvailable since isMFC2disabled is no longer available
                const inventoryAvailable = product.channelInventory[userChannelChoice]

                switch (true) {
                    // README: Scenario 1 - When user sets instore channel and product is valid
                    case (
                        userChannelChoice === 'instore'
                        && product.price > 0
                    ):
                    // README: Scenario 2 - When user sets pickup or delivery channel and product is valid
                    case (
                        ['pickup', 'delivery','shipping'].includes(userChannelChoice)
                        && (!validatePrice || product.price > 0)
                        && !['', null, undefined, '0'].includes(inventoryAvailable)
                    ):
                    // README: Scenario 3 - When channel is not set and product is valid
                    case (
                        !userChannelChoice
                        && product.price > 0
                    ):

                        if (
                            product.isMtoProduct
                            && product.preparationTime
                        ) {
                                if(Number(product.preparationTime)>0){
                                    const mtoDisplyableTime = this.prepTimeMinToHoursMins(product.preparationTime);
                                    product['mtoDisplyableTime'] = mtoDisplyableTime;
                                    product['mtoText'] = 'Takes ' + mtoDisplyableTime+' to prepare';
                                } else{
                                    product['mtoDisplyableTime']= null;
                                    product['mtoText'] = null;
                                }
                        }

                        product['itemAvailable'] = true;
                        return true;

                    // README: Scenario 4 - When item is not available
                    case product.price <= 0:
                    case (
                        ['', null, undefined, '0'].includes(inventoryAvailable)
                        && ['pickup', 'delivery', 'shipping'].includes(userChannelChoice)
                    ):

                        product['itemAvailable'] = false;
                        product['itemNotAvailableTxt'] = 'This item is out of stock';
                        product['disableInStoreUICheck'] = true;
                        return false;

                    // README: Scenario 5 (default) - Handle here all unimplemented cases
                    default:
                        return true;
                }
            }

            return false;
        }

        /**
     * Helper method which determines whether to get the inventory availability flag from the old
     * "inventoryAvailable" flag or, if enabled by the feature flag, returns the appropriate channel inventory
     *
     * @param {any} product - Object of the product on which the availability check is being done
     * @param {string} userChannelChoice - Label for the user channel
     */
    public getProductInventoryAvailability(product : any, userChannelChoice : string) {
        let inventoryAvailability;

        if (this._enableMFC2 && product.channelInventory && userChannelChoice)
            inventoryAvailability = product.channelInventory[userChannelChoice];
        else
            inventoryAvailability = product.inventoryAvailable;

        return inventoryAvailability;
    }

        /**
     * This is a helper function for checking if a product is active or not.
     *
     * @param product
     */
    public isActiveProduct(product: ProductModel) {
        if(product['status'] && product['status'] === 'inactive') {
            return false;
        } else {
            return true;
        }
    }


    // check is user has active signed in session
    public isLoggedIn(): boolean  {
        return (window['AB']['COMMON'].sessionNotExpired() && window['AB']['COMMON'].authorize())
    }


    // checks if window['analyticsSwy'] object has been processed / populated
    public checkAnalyticsSwyObject() {
        return window['analyticsSwy'] ? (window['analyticsSwy'].storedData ? (window['analyticsSwy'].storedData.ids ? true : false) : false) : false;
    }


    public checkPendingOrder = function () {
        const pendingOrderId = this._aemService.getOrderNumberCookie();
        const pendingStoreId = this._aemService.getOrderStoredIdCookie();
        return (pendingStoreId && pendingOrderId) ? true : false;
    };


    public async validateSession(callBackFn?: Function) {
        // check if user is logged in
        if ( this._userInfoService.isAuthorized() ) {
            // check if access token is active

            if ( this._utilService.isTokenActive() && this._userInfoService.getSWY_SHOP_TOKEN() ) {
                if (callBackFn) {
                    callBackFn();
                }

            // check if swy_shared_session_info cookie is present
            } else if ( this._utilService.checkAuthorizedCookie() ) {

                try {
                    // DFTA - @@TODO -- need to setup userInfo path in config
                    const objPromise =  await this.http.get(this.config.userInfoPath).toPromise();

                    // updating with the new token
                    this._userInfoService.setSWY_SHOP_TOKEN(objPromise['SWY_SHOP_TOKEN']);

                    this._utilService.updateTokenRefreshProperty();

                    if (this._utilService.isTokenActive()) {

                        if (callBackFn) {
                            callBackFn();
                        }

                    } else {

                       $('#sessionTimeoutModal').modal({'show': true});

                    }
                } catch (e) {

                    console.error('qty-stepper', e);
                   $('#sessionTimeoutModal').modal({'show': true});

                }
            } else {

                // session expired
               $('#sessionTimeoutModal').modal({'show': true});
            }
        }
      }

      /**
       * This method will generate UUID ver 4, with Timestamp and Random Number.
       * @param strHHID optional Customer HHID
       * @param strName optional Customer name.
       * @returns {string} returns the unique UUID ver 4.
       */
      public generateUUID(strHHID? , strName? ) : string {
        const dateTimeMillis = new Date().getTime();

        let random = Math.floor( performance.now() * dateTimeMillis );

        // Get the number from HHID.
        if( strHHID && strHHID.length > 0 && !isNaN(strHHID) ) {
            random += Number(strHHID);
        }

        // Generate the Base 10 of that string.
        if( strName && strName.length > 0 ){
            random += this.__encode(strName);
        }

        // Generate the UUID ver 4 using the Random Seed.
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/([xy])/g, function (character) {
            // Get the Randomized integer from 0 to 16.
            const randomized = (random + Math.random() * 16) % 16 | 0;
            random = Math.floor(random / 16);
            // replace tht character base 16 if it is x
            // else replace it with 8, 9, a or b
            return (character === 'x' ? randomized : (randomized & 0x3 | 0x8)).toString(16);
        });
      }

    // private function for converting a String to Base10.
    public __encode = function(string) {
        let number = "";
        const length = string.length;
        for (let i = 0; i < length; i++)
            number += string.charCodeAt(i).toString(10);
        return Number(number);
    };

    // get the current enviorment to be used with the wcax-env-config.ts values
    public getCurrentEnviorment() : string {
        let env = ''

        if(window.location.origin.indexOf('dev1') > 0 || window.location.origin.indexOf('dev2') > 0 || window.location.origin.indexOf('dev3') > 0 || window.location.origin.indexOf('qa1') > 0 || window.location.origin.indexOf('qa2') > 0 ||window.location.origin.indexOf('qa3') > 0 || window.location.origin.indexOf('stage') > 0){
            env = window.location.host.split('-')[1].split('.')[0];
          }else if(window.location.origin.indexOf('localhost') > 0 || window.location.origin.indexOf('local-origin') > 0){
            env = 'qa1';
          }else if(window.location.origin.indexOf('beta') > 0){
            env = 'betaprod';
          }else {
            env = 'prod';
          }
        return env;
    }

    public getWineShopSearchResultsPage(): string {
        return _window ().AB.wineShopSearchResultsPath;
    }

    public getMarketPlaceCrossSellerSearchResultsPath(): string {
        return _window ().AB.marketPlaceCrossSellerSearchResultsPath;
    }

    /**
     * returns seller landing page url
     * @param sellerId
    **/

    public getSellerLandingPath(sellerId: string): string {
        const finalSellersUrl = $('.menu-nav__wrapper').attr('data-mktp-sellers-url');
        try {
            const objMkpSellersUrl = JSON.parse(finalSellersUrl);
            return objMkpSellersUrl[sellerId] ? objMkpSellersUrl[sellerId] : '';
        } catch (e) {
            return '';
        }
    }
    // -----------------------------------------------------------------------------------------------------
    /*
    *   DFTA - methods below have been moved here during integration phase
    *   check cart id
    */
        public checkCartId = function(cname) {
            if(this._utilService.isLSCompatible()){
                if(localStorage.getItem(cname) !== undefined && localStorage.getItem(cname) !== null)
                    return true;
                else
                    return false;
            } else {
                if(this._utilService.getCookie(cname)!== undefined && this._utilService.getCookie(cname) !== null)
                    return true;
                else
                    return false;
            }
        }

        /*
            get cart id
        */
        public getCartId = function(cname) {

            return this.getCartIdV2(cname);
        }

        /* set cart id */
        public setCartId = function(cname,cid) {
            this.setCartIdV2(cname, cid);
        }

        public getCartIdV2 = function(cname, sellerId) {
            const cartListObj = this.getCartIdObjV2(cname);

            if (cartListObj) {
                return cartListObj[sellerId ? sellerId : 'abs'];
            }
        }

        public setCartIdV2 = function(cname, cid, sellerId) {

            const cartListObj = this.getCartIdObjV2(cname);

            cartListObj[sellerId ? sellerId : 'abs'] = cid;

            this.setCartIdObjV2(cname, cartListObj);
        }

        public getCartIdObjV2 = function (cname) {
            let cartList;

            if(this._utilService.isLSCompatible()){
                cartList = localStorage.getItem(cname);
            } else {
                cartList = this._utilService.getCookie(cname);
            }

            if (cartList) {
                try {
                    return JSON.parse(cartList);
                } catch(ex) {
                    console.warn('migrating old cart id', ex);
                    // for old cart ids backward compatability
                    return {abs: cartList};
                }
            }

            return {};
        }

        public setCartIdObjV2 = function(cname, cartListObj) {
            const cartString = JSON.stringify(cartListObj);

            if(this._utilService.isLSCompatible()){
                localStorage.setItem(cname, cartString);
            } else {
                this._utilService.setCookie(cname,cartString, -1);
            }
        };

    /**
     * This function is called during the initial flow for cart.service.ts . If all three ERUMs
     * edit order cookies are present, hide the reserve time navbar, and show the edit order messaging in
     * the header.
     * Then calls the ERUMs order summary service, passing in the orderNumber from the ERUMs cookie
     */
public checkPendingOrderAlert() {
    let reserveNav 			= this._utilService.readElement(this.reserveNavEl);
    const orderNumber	= this._aemService.getOrderNumberCookie();
    if ( orderNumber !== '' && this._aemService.authorize()){
        if (reserveNav && reserveNav.length > 0 ) {
            reserveNav = this._utilService.getElement(this.reserveNavEl);
            reserveNav.hide();
        }
        if ( this.checkForEditOrderMode() ) {
            const syndicatedHeader  = this._utilService.getMetaElementContent(this.isSyndicatedHeader);
            if (syndicatedHeader !== 'true'){
                const alertSlotInfo 		= this._utilService.getElement(this.slotDisplay);
                const alertCancelLink 	= this._utilService.getElement(this.reviewCTA);
                const alertHeaderRowUI 	= this._utilService.getElement(this.editOrderRowUI);
                alertCancelLink && alertCancelLink.attr('href', _window().SWY.CONFIGSERVICE.erumsConfig["spa.editorder.endpoint"]+"/cart/"
                    + this.orderStoreId + '/' + orderNumber);
                alertSlotInfo && alertSlotInfo.html(this.slotInfo);
                alertCancelLink && alertCancelLink.prop("onclick", null).off("click");
                // show edit order header row
                alertHeaderRowUI && alertHeaderRowUI.removeClass("mask");
            }
            this.eRumsDeliveryCheckCall(orderNumber);
        } else {
            this.eRumsDeliveryCheckCall(orderNumber);
        }
    }
    else {
        // To clear the Erums delivery type if OrderNumber Cookie is not present
        if ( localStorage.getItem(this.eRumsDeliveryType) ) {
            localStorage.removeItem(this.eRumsDeliveryType);
        }
        // show reserve time link on the header
        const reserveTimeEl = $(this.reserveTimeEl);
        if (reserveTimeEl){
            reserveTimeEl.show();
        } else {
            console.error('reserve-nav class not found');
        }
    }
}
    // ----------------------------------------------------------------------------
    /**
     * This function checks for two cookies that are set by ERUMs when a user chooses the
     * "shop" link on the edit order page.
     *
     * The two cookies checked for are : 'OrderStoreId' & 'OrderNumber'
     *
     *
     * @returns boolean
     */
    // -----------------------------------------------------------------------------
    private checkForEditOrderMode() {
        let result 			= false;
        const slotInfo 		= this._aemService.getSlotIdCookie();
        const orderStoreId 	= this._aemService.getOrderStoredIdCookie();
        // check for edit order cookies set by ERUMS page, OrderStoreId & SlotInfo
        if ( slotInfo !== 'undefined' && orderStoreId !== 'undefined' && slotInfo !== '' && orderStoreId !== '' ) {
            this.slotInfo 	 	= slotInfo;
            this.orderStoreId 	= orderStoreId;
            result = true;
        }
        return result;
    }

    // ----------------------------------------------------------------------------
    /**
     * Need function to replace AB.ALERT.checkPendingOrderAlert()
     *
     */
    // -----------------------------------------------------------------------------
    private eRumsDeliveryCheckCall(pendingOrderId) {
        const $this = this;
        let orderDetails: any 	= '';

        // check for order details in local storage
        if ( localStorage.getItem(this.eRumsDeliveryType) ) {
            orderDetails = JSON.parse(localStorage.getItem(this.eRumsDeliveryType));
        }

        if ( orderDetails != "" && orderDetails.orderId == pendingOrderId && orderDetails.deliveryType == 'Unattended' ) {
            this.unattendedDeliveryWrapper(orderDetails.deliveryType);
        }
        else {
            // check if erums order api v1 is being used
            const baseDomainUrl= this.config[this.getCurrentEnviorment()]?.baseURL?.replace("{banner}", this._userInfoService.getBanner())
            if (this._aemService.getEditOrderOldVersion() === true) {
                // if no order details in local storage, call ERUMs order summary service and set local storage
               const url 		 	=  baseDomainUrl + _window().AB.erumsOrderDelivery;
               const eRumsHeaders 	= _window().AB.ecommHttpOptionsErums;
                $.ajax({
                    headers:  eRumsHeaders,
                    url: 	  url + pendingOrderId,
                    dataType: "json",
                    success:  function (data) {
                        localStorage.setItem(
                            $this.eRumsDeliveryType,
                            JSON.stringify({
                                    'orderId':data.order.orderId,
                                    'deliveryType':data.order.deliveryType
                                }));

                        $this.setABCartLS(data);

                        $this.unattendedDeliveryWrapper(data.order.deliveryType);
                    },
                    error: function (jqXHR, text, error) {
                        //console.log(error);
                    }
                });
            }   // check if erums order api v1 is NOT being used
            else if (this._aemService.getEditOrderOldVersion() === false) {
                // get edit order store id
                this.orderStoreId   = this._aemService.getOrderStoredIdCookie();
                // if no order details in local storage, call ERUMs order summary service and set local storage
                const url 		 	= baseDomainUrl + _window().AB.erumsOrderDelivery;
                const eRumsHeaders 	= _window().AB.ecommHttpOptionsErums;
                $.ajax({
                    headers:  eRumsHeaders,
                    url: 	  url + this.orderStoreId + '/' + pendingOrderId,
                    dataType: "json",
                    success:  function (data) {
                        localStorage.setItem(
                            $this.eRumsDeliveryType,
                            JSON.stringify({
                                'orderId':data.orderId,
                                'deliveryType':data.deliveryType
                            }));

                        $this.setABCartLS(data);

                        let timeSlot;
                        let slotId
                        if (data && data.deliveryInfo && data.deliveryInfo.slotInfo) {
                            const slotInfo = data.deliveryInfo.slotInfo;
                            if (slotInfo.displayStartTS) {
                                timeSlot = slotInfo.displayStartTS;
                                timeSlot = Date.parse(timeSlot);
                            }

                            if (slotInfo.slotId) {
                                slotId = slotInfo.slotId
                            }
                        }
                        let serviceType;
                        if (data && data.serviceType) {
                            serviceType = data.serviceType.toLowerCase();
                            serviceType = (serviceType === 'dug') ? 'pickup' : 'delivery';
                        }
                        localStorage.setItem('abSlotEditOrder', JSON.stringify({'timeSlot': timeSlot, 'slotId': slotId, 'serviceType': serviceType}));
                        // update local session's zipcode with the order's store zipcode
                        $this.editOrderZipCodeUpdate(data.customerInfo.zipCode)
                        // update local session's preference based on pending order delivery type
                        $this.editOrderPreferenceUpdate(data.deliveryType);
                        $this.unattendedDeliveryWrapper(data.deliveryType);
                    },
                    error: function (jqXHR, text, error) {
                        //console.log(error);
                    }
                });
            }
        }
    }

    //----------------------------------------------------------------------------
    /**
     * This function updates the local session's zipcode to the one of the order that is currently
     * being edited. The updateUserSession() is used to update the SWY session cookies, but does not update UCA
     *
     * We get the pending order store's zipcode via the erums orderservice API response
     *
     * @returns void
     */
    //-----------------------------------------------------------------------------
    private editOrderZipCodeUpdate(orderZipCode) {
    	const sessionObj: any 		= { 'info': { 'COMMON': {}, 'J4U': {}, 'SHOP': {} } };

		// set zipcode to J4U / SHOP and COMMON
    	sessionObj.info.COMMON.zipcode 	= orderZipCode;
		sessionObj.info.J4U.zipcode 	= orderZipCode;
		sessionObj.info.SHOP.zipcode 	= orderZipCode;
		// update session for AEM pages cookies - no reload - no UCA update
		_window().AB.COMMON.updateUserSession(sessionObj, false);

        //Update user session in angular library
        this._userInfoService.setUserSession({...this._userInfoService.getUserSession(), shopZipcode: orderZipCode, j4uZipcode: orderZipCode})
    }

    private editOrderPreferenceUpdate (deliveryType) {
        const sessionObj: any = { 'info': { 'COMMON': {}, 'J4U': {}, 'SHOP': {} } };
        let preference = '';

        // check if delivery type has value -- meaning it's either Attended or Unattended
        if (deliveryType) {
            preference = 'delivery';
        }
        else {  // no delivery type means it's dug order
            preference = 'dug';
        }
        // update AB user info preference mode
        _window().AB.userInfo.preferenceMode = preference;
        // update the cookie with the right preference
        sessionObj.info.COMMON.preference = preference;
        // update session cookies - no reload - no UCA update
        _window().AB.COMMON.updateUserSession(sessionObj, false);

        //Update user session in angular library
        this._userInfoService.setUserSession({...this._userInfoService.getUserSession(), preference: preference})
    }

    private unattendedDeliveryWrapper(DeliveryType){
        this.checkUnAttendedEditOrderDelivery(DeliveryType);
    }

    private checkUnAttendedEditOrderDelivery(deliveryType) {
        if (deliveryType == 'Unattended') {
            _window().AB.unattendedDeliveryIsEnabled = true;
            this.updateProductRelatedComponents();
        }
    };

    private updateProductRelatedComponents () {
        if (window['productGenericGridCompRef'] != undefined) {
            window['productGenericGridCompRef'].zone.run(function () {
                window['productGenericGridCompRef'].component.checkRestrictedItems();
            });
        }
        if (window['productSearchGridCompRef'] != undefined) {
            window['productSearchGridCompRef'].zone.run(function () {
                window['productSearchGridCompRef'].component.checkRestrictedItems();
            });
        }
        if (window['productHybridGridCompRef'] != undefined) {
            window['productHybridGridCompRef'].zone.run(function () {
                window['productHybridGridCompRef'].component.checkRestrictedItems();
            });
        }
        if (window['productDynamicGridCompRef'] != undefined) {
            window['productDynamicGridCompRef'].zone.run(function () {
                window['productDynamicGridCompRef'].component.checkRestrictedItems();
            });
        }
        $('product-carousel, product-detail').each(function () {
            const id = $(this).attr('id');
            if (window[id + '_CompRef'] != undefined) {
                window[id + '_CompRef'].zone.run(function () {
                    window[id + '_CompRef'].component.checkRestrictedItems();
                });
            }
        });
    };

    private setABCartLS(abCartObj) {
        localStorage.setItem(
            'abCart',
            JSON.stringify({
                branchId: abCartObj.storeId ? abCartObj.storeId : '',
                cartItems: abCartObj.orderItems ? abCartObj.orderItems : [],
                cartPrice: abCartObj.orderSummary?.estimatedSubTotal || abCartObj.wysiwygOrderSummary?.estimatedSubTotal || '',
                cartQty: abCartObj.orderSummary?.totalItemQuantity || abCartObj.wysiwygOrderSummary?.totalItemQuantity || 0,
                erumsStore: true,
                isWYSIWYGEnabled: abCartObj.isWYSIWYGEnabled,
                orderNumber: abCartObj.orderId ? abCartObj.orderId : '',
                isFutureOrder: abCartObj.isFutureOrder || false
            }));
        this.loadPendingOrderData();
    }

    private loadPendingOrderData() {
        if (window['cartServiceRefAL'] != undefined) {
            window['cartServiceRefAL'].zone.run(function () {
                window['cartServiceRefAL'].service.loadPendingOrderData();
            });
        }
    }

      /**
     * ** Handles giving the correct out of stock messaging for BIA OOS redesign
     *
     * Method validating the availability flow for a given product. This method handles the out of stock (OOS) check.
     * It returns true/false based on product stock availability.
     *
     * @param {any} product - Object of the product on which the availability check is being done
     * @param {string} userChannelChoice - Label for the user channel
     * @return {boolean}
     */
   public checkItemAvailability_v3(product: any, userChannelChoice: string, outOfStockMessge='Out of Stock', isDigitalDeliProductStoreNotEligible = false): boolean {

    if (product && product.channelInventory && product.channelInventory[userChannelChoice]) {

        // product.channelInventory[userChannelChoice] will be used instead of product.inventoryAvailable since isMFC2disabled is no longer available
        const inventoryAvailable = product.channelInventory[userChannelChoice]

        switch (true) {

            case isDigitalDeliProductStoreNotEligible:
                if(!this.isCateringEnabled) {
                    product['itemAvailable'] = false;
                    product['itemNotAvailableTxt'] = outOfStockMessge;
                    product['disableInStoreUICheck'] = true;
                    return false;
                }

            // README: Scenario 1 - When user sets instore channel and product is valid
            case (
                userChannelChoice === 'instore'
                && product.price > 0
            ):
            // README: Scenario 2 - When user sets pickup or delivery channel and product is valid
            case (
                ['pickup', 'delivery','shipping'].includes(userChannelChoice)
                && product.price > 0
                && !['', null, undefined, '0'].includes(inventoryAvailable)
            ):
            // README: Scenario 3 - When channel is not set and product is valid
            case (
                !userChannelChoice
                && product.price > 0
            ):

                if (
                    product.isMtoProduct
                    && product.preparationTime
                ) {
                    if (Number(product.preparationTime) > 0) {
                        const mtoDisplyableTime = this.prepTimeMinToHoursMins(product.preparationTime  );
                        const mtoTagText = this.prepTimeMinToHoursMins(product.preparationTime , true );
                        product['mtoDisplyableTime'] = mtoDisplyableTime;
                        product['mtoText'] = 'Takes ' + mtoDisplyableTime + ' to prepare';
                        product['mtoTagText'] = mtoTagText;
                    } else {
                        product['mtoDisplyableTime'] = null;
                        product['mtoText'] = null;
                        product['mtoTagText'] = null;

                    }
                }

                product['itemAvailable'] = true;
                return true;

            // README: Scenario 4 - When item is not available
            case product.price <= 0:
            case (
                ['', null, undefined, '0'].includes(inventoryAvailable)
                && ['pickup', 'delivery', 'shipping'].includes(userChannelChoice)
            ):

                product['itemAvailable'] = false;
                product['itemNotAvailableTxt'] = outOfStockMessge;
                product['disableInStoreUICheck'] = true;
                return false;

            // README: Scenario 5 (default) - Handle here all unimplemented cases
            default:
                return true;
        }
    }

        return false;
    }

        /**
     * Convert minutes in hours minutes format
     *
     * @param string prepareTimeInMinutes
     * @returns string format in hours minutes format
     */

    public prepTimeMinToHoursMins(prepareTimeInMinutes: string , isTagText = false): string {
        const timeInMinutes = Number(prepareTimeInMinutes);
        const hrs = Math.floor(timeInMinutes/60);
        const minutes = timeInMinutes%60;
        if(isTagText){
            if(hrs>0)
                return  hrs+( hrs > 1?" hrs":" hr")+(minutes>0? " "+minutes+" mins":"") + " prep";
            return 'Made to Order';
        }
        if(hrs>0)
            return  hrs+( hrs > 1?" Hours":" Hour")+(minutes>0? " "+minutes+" Minutes":"");
        return minutes+" Minutes";
    }

    /* get cart id */
    public removeCartId(cname, sellerId?) {
        if (sellerId) {
            const cartListObj = this.getCartIdObjV2(cname);

            if(cartListObj.hasOwnProperty(sellerId)) {
                delete cartListObj[sellerId];
            }

            this.setCartIdObjV2(cname, cartListObj);
        } else {
            if(this._aemService.isLSCompatible()){
                localStorage.removeItem(cname);
            } else {
                document.cookie = cname+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
        }
    }

    public getB2BCartList (): string {
        return _window ().SWY.CONFIGSERVICE?.bannerConventionsJson?.B2BCartList;
    }

    public getCartList (): string {
        return _window ().SWY.CONFIGSERVICE?.bannerConventionsJson?.cartList;
    }

    public getParams(params) {
        const param = new URLSearchParams(window.location.search);
        return param.get(params) ? param.get(params) : null;
    }

    /**
     * Method for showing the substituions api driven cross sell component on BIA landing page
     *
     */
    public showBiaLPCrossSell(bpn: string, isDynamicGridFlow = false) {
        let relevancyUrl = '';
        let httpOptions: any;
        // @@TODO - change back to dyncamic xAPIBasePath after testing on QA1
        const xAPIBasePath = window.location.origin + this._aemService.getApimSearchPath();
        //let xAPIBasePath = 'https://www.safeway.com/abs/pub/xapi';


        const hhid = this._userInfoService.getHouseId() ? this._userInfoService.getHouseId() : '';

        const storeId = this._userInfoService.getShopStoreId()
            ? this._userInfoService.getShopStoreId() : '';

        const channel = this._userInfoService.getUserChannel();
        // encode _br_uid_2 when passed as query param - when added to payload do not encode
        const brUid = encodeURIComponent(this._aemService.getCookie('_br_uid_2'));

        const pageUrl = window.location.hostname;

        if (bpn && hhid && storeId && channel) {
            relevancyUrl = `${xAPIBasePath}/pdreco/substitution?bpn=${bpn}&storeId=${storeId}&hhid=${hhid}&channel=${channel}&bruid=${brUid}&pageurl=${pageUrl}&availabilityCheck=true&placement=bia`;
            // @@TODO - change back to dyncamic Key after testing on QA1
            httpOptions = {
                headers: new HttpHeaders({
                    'Ocp-Apim-Subscription-Key': this._aemService.getXApiKey(),
                    'accept': 'application/json'
                })
            };

            if (this._userInfoService.getSiteType() && this._userInfoService.getSiteType().toUpperCase() === 'B') {
                httpOptions.headers = httpOptions.headers.set('pgm','1P_B2B');
            }

            this.http.get<ProductModel[]>(relevancyUrl, httpOptions).subscribe(( objResponse ) => {
                if (objResponse && objResponse['productsinfo'] )
                {
                    const formattedResponse = {'products': objResponse?.['productsinfo'], 'bpn': bpn, 'isDynamicGridFlow': isDynamicGridFlow};
                    formattedResponse['placement'] = 'bia-lp';
                    this.crossSellTargetSource.next(formattedResponse);
                    if (window['AB'] && window['AB']['DATALAYER']) {
                        window['AB']['DATALAYER'].getBiaOosAdobeMetrics(objResponse['productsinfo']);
                    }
                } else {
                    // send empty response to show empty state UI
                    const formattedResponse = {'products': [], 'bpn': bpn, 'isDynamicGridFlow': isDynamicGridFlow};
                    formattedResponse['placement'] = 'bia-lp';
                    this.crossSellTargetSource.next(formattedResponse);
                }
            }, error => {
                 // send empty response to show empty state UI
                 const formattedResponse = {'products': [], 'bpn': bpn};
                 formattedResponse['placement'] = 'bia-lp';
                 this.crossSellTargetSource.next(formattedResponse);
            });
        }
    }
    public recordRelevanceImpression(product, component, context) {
        if (this.isSearchPage()) {
            const amcSessionId = this._utilService.getCookie('AMCV_A7BF3BC75245ADF20A490D4D@AdobeOrg');
            let relevanceObj: any = {
                "item": product.id,
                "price": product.price,
                "quantity": "1",
                "environment": "d",
                "retailer-visitor-id": amcSessionId ? amcSessionId?.match(/MCMID\|\d+(?=\|)/)[0]?.split('|')[1] : null
            }
            if (context == "viewProductDetails") {
                relevanceObj = {
                    ...relevanceObj,
                    "page-id": "viewItem_API_desktop",
                    "event-type": "viewItem",
                    "availability": "1",
                    "category": product?.aisleId?.replaceAll('_', '>')
                }
            } else {
                relevanceObj = {
                    ...relevanceObj,
                    "page-id": "viewSearchResult_API_desktop",
                    "event-type": "addToCart"
                }
            }
            if (relevanceObj &&
                window['citrusAdTracker'] &&
                typeof window['citrusAdTracker'] === 'function') {
                window['citrusAdTracker'](relevanceObj, 'AD_RELEVANCE', {
                    component,
                    context
                });
            }
        }
    }
    public isSearchPage() {
        return window.location.pathname?.toLowerCase().indexOf('shop/search-results') != -1;
    }
    public sendSponsoredProductsOnloadEvent(products, component, context?) {
        if (products && products.length > 0) {
            const productTrackingList = products.map(x => x.eventTracking).filter(x => x != undefined);
            if (productTrackingList && productTrackingList.length > 0 &&
                window['citrusAdTracker'] &&
                typeof window['citrusAdTracker'] === 'function') {
                window['citrusAdTracker'](productTrackingList, 'AD_ONLOAD', {
                    component: component,
                    context: context ? context : 'sponsoredProductsLoaded'
                });
            }
        }
    }

    public sendSponsoredProductClickEvent(product, component, context) {
        const productTracking = product['adId'] || product.eventTracking;
	if (productTracking && window['citrusAdTracker'] && typeof window['citrusAdTracker'] === 'function') {
            if (this.duplicateProductsObj[product.pid]) {
                return;
            }
            this.duplicateProductsObj[product.pid] = true;

            window['citrusAdTracker'](productTracking, 'AD_CLICK', {
                component: component,
                context: context
            });
	}
    }

    // Fires sendSponsoredProductClickEvent only on routes listed in CRITEO_CLICK_ALLOWED_ROUTES.
    // Used by CTAs gated to the Savings Hub rollout. Remove the gate and replace callers
    // with the unguarded method when AMC validation is complete.
    public sendSponsoredProductClickEventForAllowedRoutes(product, component, context) {
        if (!product || typeof window === 'undefined' || !window.location) {
            return;
        }
        const pathname = window.location.pathname || '';
        if (!pathname) {
            return;
        }
        const isAllowed = CommonService.CRITEO_CLICK_ALLOWED_ROUTES.some(
            route => typeof route === 'string' && route.length > 0 && pathname.startsWith(route)
        );
        if (isAllowed) {
            this.sendSponsoredProductClickEvent(product, component, context);
        }
    }

    // delay the function calling for 600 milliseconds
    public debounce(func: Function, delay: number = 600) {
        let timeoutId: any;
        let shouldExecute = false;

        return function(...args: any[]) {
            const context = this;
            clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                if (shouldExecute) {
                    func.apply(context, args);
                    shouldExecute = false;
                }
            }, delay);
            shouldExecute = true;
        };
    }

    /*
      * Generic custom event dispatcher
      * @Param {string} eventName - name of the event to dispatch
      * @Param {string} type - type of event that has happened
      * @Param {any} payloadData - payload data to be sent with event
    */
    public dispatchCustomOneTimeEvent(eventName: string, type: string, payloadData: any): void {
        window.dispatchEvent(new CustomEvent(eventName, {
            detail: {
                type,
                ...payloadData
            }
        }));
    }

    // --------------------------------------------------------------------------
    /**
     *  FLAG:         hasPageV2Theme
     *  DESCRIPTION:  Used to determine whether the displayed page supports
     *                v2 theme.
     */
    // --------------------------------------------------------------------------
    public hasPageV2Theme(): boolean {
        const pageV2ThemAttribute = "data-enablev2theme";

        let hasV2Theme = false;
        if (this.getPageAttribute(pageV2ThemAttribute) === 'true')
        hasV2Theme = true;

        return hasV2Theme;
    }

 // --------------------------------------------------------------------------
  /**
   *  FLAG:         getPageAttribute
   *  DESCRIPTION:  Returns the specified attribute value from the header
   *                element.
   */
  // --------------------------------------------------------------------------
  public getPageAttribute(pageAttribute: string): string {
    return this.getHeaderElement().attr(pageAttribute);
  }

  // --------------------------------------------------------------------------
  /**
   *  FLAG:         getHeaderElement
   *  DESCRIPTION:  Returns the header element which contains the page-specific
   *                attributes.
   */
  // --------------------------------------------------------------------------
  public getHeaderElement() {
    const headerSelector = '.main-wrapper.www-wrapper';
    return $(headerSelector);
  }

  public handleTabFocus(e, modelId: string, nativeElement, focusableElements: string) {
    const focusableContent = nativeElement.querySelector(modelId).querySelectorAll(focusableElements);
    const visibleFocusableElement = [];
    focusableContent.forEach((focusable) => {
        if ($(focusable).is(':visible')) {
            visibleFocusableElement.push(focusable)
        }
    })
    const firstFocusableElement = visibleFocusableElement[0]; // get first element to be focused inside modal
    const lastFocusableElement = visibleFocusableElement[visibleFocusableElement.length - 1]; // get last element to be focused inside modal

    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
        return;
    }
    if (e.shiftKey) { // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus(); // add focus for the last focusable element
            e.preventDefault();
        }
    } else { // if tab key is pressed
        if (document.activeElement === lastFocusableElement) {
            // if focused has reached to last focusable element then focus first focusable element after pressing tab
            firstFocusableElement.focus(); // add focus for the first focusable element
            e.preventDefault();
        }
    }
}
    /**
         * Checks if the preparation time of an MTO product exceeds the Prebooked time
         *
         * @param product - the product to be added to cart
         *
         * @param slot - key for local storage
     */
    public preparationTimeExceedsPrebook(product, slot): boolean {
        const slotInfo = localStorage.getItem(slot);
        if (!slotInfo) {
            return false; // No slot info available
        }

        const slotDetails = JSON.parse(slotInfo);
        const prebookedTime = parseInt(slotDetails.timeSlot, 0);

        if (product.isPreOrderItem && product.itemEffectiveStartDate) {
            const prebookedDate: string = new Date(prebookedTime).toISOString()?.slice(0, 10); // format date to YYYY-MM-DD
            const itemEffectiveDate: string = product.itemEffectiveStartDate.slice(0, 10); // format date to YYYY-MM-DD
            return prebookedDate < itemEffectiveDate;
        }
     
        if (prebookedTime && product.preparationTime) {
            const timeUntilPrebook = prebookedTime - Date.now();
            const preparationTime = product.preparationTime * 60 * 1000;
            return preparationTime > timeUntilPrebook;
        }
        return false;
    }

  /**
  * Method validating and setting product price value if a promo is currently active or not.
  * Use basePrice prop if promo is not active, otherwise use price prop.
  */
  public getValidProductPrice = (product) => {
    if(product === null){
        return 0;
    }
    if (
      this.hasPromotion(product) === false
      || this.isProductPromoActive(product)
    ) {
      return product.price;
    }
    return product.basePrice;
  }

     /**
     * Method to check for the AB flag and give subscribers of isABFlagDisabledEvent the value of the flag
     * @param lsFlagName localStorage flag name that is set for AB test
     * @param featureFlagName feature flag name that is set in Author
     * @param windowFlagName window flag name that is set by analytics team
     * @param timeoutValue timeout value in milliseconds to wait for the event to be triggered
     */
     public listenToABXTestingFlag(lsFlagName: string, featureFlagName: string, windowFlagName: string, timeoutValue: number = 5000) {
        if(this._aemService.getFeatureFlagByNameDisable(featureFlagName)){
            localStorage.removeItem(lsFlagName);
            this.isABFlagDisabledEvent.next({flagName: featureFlagName, testValue: 'a'});
        }else {
            const lsFlagValue = localStorage.getItem(lsFlagName);
            if(lsFlagValue){
                this.isABFlagDisabledEvent.next({flagName: featureFlagName, testValue: lsFlagValue});
            }
            else {
                if (window?.["analyticsSwy"]?.["testFlags"]?.[windowFlagName]) {
                    const windowFlagValue = window["analyticsSwy"]["testFlags"][windowFlagName];
                    this.isABFlagDisabledEvent.next({flagName: featureFlagName, testValue: windowFlagValue});
                } else {
                    // eslint-disable-next-line prefer-const
                    let timeoutId;
                    const eventHandler = (event) => {
                        clearTimeout(timeoutId);
                        const value = event['detail'][windowFlagName];
                        this.isABFlagDisabledEvent.next({flagName: featureFlagName, testValue: value});
                    };

                    // Add the event listener
                    //The once: true option ensures that the event listener is removed after it is triggered
                    window.addEventListener(windowFlagName, eventHandler, { once: true });

                     // Function to remove the event listener
                    const removeEventListener = () => {
                        window.removeEventListener(windowFlagName, eventHandler);
                        this.isABFlagDisabledEvent.next({flagName: featureFlagName, testValue: 'a'});
                    };
                    // Set a timeout to remove the event listener after 5000 milliseconds if the event is not triggered
                     timeoutId = setTimeout(removeEventListener, timeoutValue);

                }
            }

        }
    }

    /**
     * Method to check if the offer is NDC and eligible to BXGY offer
     * @param offer
     */
    public getIsOfferEligibleBXGY(offer: any) {
         return offer?.offerProtoType === 'BUYX_GETY' && !offer?.offerDetail?.isClippable && offer?.offerDetail?.promoType !== 'M' && offer?.offerDetail?.promoType !== 'B';
    }
    /**
     * This method will return if product is eligible for customizable product
     * @param product
     * @returns boolean true/false
     */
    public isCustomizableProduct(product: any): boolean {
        return !!(product.isMtoProduct && product.isCustomizable);
    }
    /**
     * This method will return if user store is eligible for ecomm deli
     * @param storeFlags
     * @returns boolean true/false
     */
    public isProductEligibleForCustomization(storeFlags: any, product: any): boolean {
        const departmentArray = storeFlags?.flags?.departmentsDetail;
        return this.isCustomizableProduct(product) && (departmentArray?.[0]?.acuview1POrderprep ?? false);
    }

    /**
     * This method returns true for Customize CTA, false for Temporarily Unavailable CTA and null for default CTA
     * @param product
     * @returns boolean true/false or null
     */
    public getIsEcomEnabled(product): boolean | null{
        if (this.isCateringEnabled) {
            const dept = window['AB']?.['storeFlagsData']?.['flags']?.['departmentsDetail']?.find((item: any) =>
                item?.departmentId === product?.serviceDeptNum);

            const isCatering = !!product?.isCateringProduct;
            const isCustomCake = !!product?.isCustomCake;
            if (
                !dept ||
                !product?.isMtoProduct ||
                ((!isCatering && !isCustomCake ) && (!product?.isCustomizable ))
            ) { return null; }

            if (typeof dept?.isCateringEnabled === 'undefined' || typeof dept?.isECOM1PEnabled === 'undefined'
                || typeof dept?.serviceDepartEnabled === 'undefined') { return false; }

            if (dept?.serviceDepartEnabled && (!isCatering && !isCustomCake)
                && !dept?.isECOM1PEnabled && !product?.multiCustomizations) { return null; }

            return dept?.serviceDepartEnabled
                ? (isCatering ? dept?.isCateringEnabled : dept?.isECOM1PEnabled) // Customize CTA
                : false; // Temporarily Unavailable CTA
        } else {
            window['AB']?.['storeFlagsData']?.['flags']?.['departmentsDetail']
            ?.find((item) => item?.departmentName?.toLowerCase() === 'deli')?.isECOM1PEnabled || false;
        }
    }

    /**
     * This method returns true if its a multicustomizable product but only customizable instore.
     * @param product
     * @returns boolean true/false
     */
     public isDigitalDeliProductStoreNotEligible(product) {
        const isDigitalDeliDisabledFlag = !this._aemService.getFeatureFlagByNameDisable('isDigitalDeliDisabled');
        const { isMtoProduct = false, isCustomizable = false, multiCustomizations = false} = product || {};
        const isEcomEnabled = this.getIsEcomEnabled(product);
        return isDigitalDeliDisabledFlag && !isEcomEnabled && isMtoProduct && isCustomizable && multiCustomizations;
    }

    /**
     * Determines if a given product is eligible as a custom cake product.
     *
     * Eligibility requires:
     * - The "Custom Cakes" feature flag is enabled.
     * - The product is marked as a made-to-order product (`isMtoProduct`).
     * - The product is customizable (`isCustomizable`).
     * - The product is identified as a custom cake (`isCustomCake`).
     *
     * @param product - The product object to evaluate. Should contain `isMtoProduct`, `isCustomizable`, and `isCustomCake` properties.
     * @returns `true` if the product is eligible as a custom cake; otherwise, `false`.
     */
    public isEligibleCustomCakeProduct(product) {
        const isCustomCakesEnabled = !this._aemService.getFeatureFlagByNameDisable('isCustomCakesDisabled');
        const isEcomEnabled = this.getIsEcomEnabled(product);
        const { isMtoProduct = false, isCustomizable = false, isCustomCake = false } = product || {};
        return isCustomCakesEnabled && isMtoProduct && isCustomizable && isCustomCake && isEcomEnabled;
    }


    /**
     * Creates a deep clone of the provided input object.
     * @param input - The object to be deeply cloned.
     * @returns A new object that is a deep clone of the input.
     */
    public cloneDeep(input: any) : any {
        if (input === undefined) {
            return undefined;
        }
        return JSON.parse(JSON.stringify(input));
    }

    /**
      * Updates customizationData signal.
      * @param customizationUpdates - New updates that needs to be done on customization signal.
      */
    public updateCustomizationData(customizationUpdates: any): void {
        this.customizationData.update((previousCustomizationData) => ({
            ...previousCustomizationData,
            ...customizationUpdates,
            isUpdated: true
        }));
    }

    /**
     * Reset customizationData signal.
     */
    public resetCustomizationData(): void {
        this.customizationData.set({ isUpdated: false, selectedOptions: null, selectedQuantity: null, productId: null, comments:null });
    }

    // ========================================
    // A/B Testing Functionality
    // ========================================

    /**
     * Get experiment data from XER (Experimentation) Web SDK
     * @param experimentId - The experiment ID to test
     * @param isOndemandFlow - Whether the experiment is for on-demand flow (true) or pre-fetch flow (false)
     * @returns Promise with the feature object from XER response, or null if not found/error
     */
    public async getExperimentIdData(featureId: string, isOndemandFlow: boolean = false): Promise<any> {
        try {
            // Check if Web SDK is available
            if (!this.isExperimentModuleAvailable()) {
                return null;
            }

            // Call AB.experimentation.getExperimentByID with onDemand parameter
            const xerResponse = await window['AB'].experimentation.getExperimentByID(featureId, isOndemandFlow);
            
            // Check if XER response has features array
            if (xerResponse?.features && Array.isArray(xerResponse?.features) && xerResponse?.features?.length > 0) {
                // Find the feature matching the featureId
                const xerData = xerResponse?.features?.find((f: any) => f?.featureId === featureId);
                
                // Return the xerData object. If not found, return null
                return xerData || null;
            }
            
            return null;
        } catch (error) {
            console.error('A/B Test SDK error:', error);
            return null;
        }
    }

    /**
     * Check if Web SDK with experimentation module is available
     * @returns boolean
     */
    private isExperimentModuleAvailable(): boolean {
        return !!(
            window['AB'] && 
            window['AB'].experimentation && 
            typeof window['AB'].experimentation.getExperimentByID === 'function'
        );
    }

    /**
     * Returns true if the total selected quantity for a given modifier has reached or exceeded maxSelect.
     * @param modifier - The modifier object
     * @param selectedOptions - The selectedOptions array from signal
     * @returns boolean - Whether the max quantity is reached
     */
    public isMaxQuantityReachedForModifier(modifier: any, selectedOptions: any[]): boolean {
        if (!modifier?.options || !selectedOptions || !modifier?.maxSelect) return false;

        let total = 0;
        for (const opt of modifier.options) {
            const found = selectedOptions.find(sel => sel?.upcId === opt?.upcId);
            total += (typeof found?.qty === 'number') ? found.qty : (found?.isSelected ? 1 : 0);
        }
        return total >= modifier.maxSelect;
    }

    /**
     * Returns true if the minimum selection requirement (>= 1) is satisfied for a given modifier.
     * @param modifier - The modifier object containing minSelect requirement
     * @param selectedOptions - The selectedOptions array from signal
     * @returns boolean - Whether the minimum selection requirement is satisfied
     */
    public isMinSelectSatisfied(modifier: any, selectedOptions: any[]): boolean {
        if (!modifier?.options || !selectedOptions) return false;
        
        // If minSelect is not defined or is 0, consider requirement as satisfied
        if (!modifier?.minSelect || modifier.minSelect < 1) return true;

        let total = 0;
        for (const opt of modifier.options) {
            const found = selectedOptions.find(sel => sel?.upcId === opt?.upcId);
            total += (typeof found?.qty === 'number') ? found.qty : (found?.isSelected ? 1 : 0);
        }
        return total >= modifier.minSelect;
    }

    public isFeatureEnabled(featureName: string): boolean {
        return this._aemService.getFeatureFlagBase()?.[featureName] === true;
    }


    async updateViewAllExperimentRoute(): Promise<string | null> {
      const EXPERIMENT_ID = 'ACIP548280';
      const sdk = window['AB'] && window['AB'].experimentation;
      const swyConfig = window['SWY'] && window['SWY'].CONFIGSERVICE && window['SWY'].CONFIGSERVICE.featureToggleConfig;
      const enableSavingsHubByBanner = swyConfig ? swyConfig.enableSavingsHub : undefined;

      if (!sdk || typeof sdk.getExperimentByID !== 'function' || !enableSavingsHubByBanner) {
        return null;
      }

      try {
        const response = await sdk.getExperimentByID(EXPERIMENT_ID, false);
        const features = (response && Array.isArray(response.features)) ? response.features : [];
        const feature = features.find(function (f) { return f && f.featureId === EXPERIMENT_ID; }) || null;

        if (!feature || !feature.eligible) {
          return null;
        }

        switch (feature.group) {
          case 'C':
            return '/loyalty/discovery';
          default:
            return null;
        }
      } catch {
        return null;
      }
    }

    /**
     * Checks whether the user's current shopping mode (channel) mismatches the item's channel eligibility.
     * When the feature flag isMtoChannelEligibilityEnabled is enabled and there is a mismatch,
     * the Reserve Slot (MTO) modal should be suppressed and the item added silently to the correct cart group.
     * The customer's pre-selected slot for their own channel is fully preserved — it is not dropped or modified.
     *
     * @param product - the product to be added to cart
     * @returns true when modal suppression is required (channel mismatch), false otherwise
     */
    public byPassReserveSlotCheck(product): boolean {
        // Only apply suppression logic when the feature flag is disabled (false).
        // isMtoChannelEligibilityEnabled = true  → old behavior (no suppression).
        // isMtoChannelEligibilityEnabled = false → new behavior (suppress modal on channel mismatch).
        if (this.isFeatureEnabled('isMtoChannelEligibilityEnabled')) {
            return false;
        }
        if (!product.isMtoProduct) {
            return false;
        }
        const userPreference = this._userInfoService.getPreference();
        const preferenceToChannelKey: Record<string, string> = {
            'DELIVERY': 'delivery',
            'DUG': 'pickUp',
            'J4U': 'inStore',
            'SHIPPING': 'shipping',
        };
        const channelKeyName = preferenceToChannelKey[userPreference?.toUpperCase()];
        if (!channelKeyName) {
            return false;
        }
        const channelEligibility = product.channelEligibility;
        if (!channelEligibility) {
            return false;
        }
        // Mismatch: product is NOT eligible for the user's current channel → suppress modal
        return channelEligibility[channelKeyName] === false;
    }
}
